export enum DirectControlButtonActionModalEnum {
    CancelAddedProduct = 'Cancel Insuruance',
    ReviveProduct = 'OpzeggingAnnuleren',
    NewCar = 'New Car Insurance',
    NewMotor = 'New Motor Insurance',
    NewHome = 'New Home Insurance',
}
